var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9997 22.73C36.9797 22.73 36.9497 22.73 36.9197 22.73C31.6297 22.2 26.3497 22 21.1197 22.53L19.0797 22.73C18.6597 22.77 18.2897 22.47 18.2497 22.05C18.2097 21.63 18.5097 21.27 18.9197 21.23L20.9597 21.03C26.2797 20.49 31.6697 20.7 37.0697 21.23C37.4797 21.27 37.7797 21.64 37.7397 22.05C37.7097 22.44 37.3797 22.73 36.9997 22.73Z",
    fill: "#D92D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5007 21.72C24.4607 21.72 24.4207 21.72 24.3707 21.71C23.9707 21.64 23.6907 21.25 23.7607 20.85L23.9807 19.54C24.1407 18.58 24.3607 17.25 26.6907 17.25H29.3107C31.6507 17.25 31.8707 18.63 32.0207 19.55L32.2407 20.85C32.3107 21.26 32.0307 21.65 31.6307 21.71C31.2207 21.78 30.8307 21.5 30.7707 21.1L30.5507 19.8C30.4107 18.93 30.3807 18.76 29.3207 18.76H26.7007C25.6407 18.76 25.6207 18.9 25.4707 19.79L25.2407 21.09C25.1807 21.46 24.8607 21.72 24.5007 21.72Z",
    fill: "#D92D20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2104 38.7501H24.7904C21.3004 38.7501 21.1604 36.8201 21.0504 35.2601L20.4004 25.1901C20.3704 24.7801 20.6904 24.4201 21.1004 24.3901C21.5204 24.3701 21.8704 24.6801 21.9004 25.0901L22.5504 35.1601C22.6604 36.6801 22.7004 37.2501 24.7904 37.2501H31.2104C33.3104 37.2501 33.3504 36.6801 33.4504 35.1601L34.1004 25.0901C34.1304 24.6801 34.4904 24.3701 34.9004 24.3901C35.3104 24.4201 35.6304 24.7701 35.6004 25.1901L34.9504 35.2601C34.8404 36.8201 34.7004 38.7501 31.2104 38.7501Z",
    fill: "#D92D20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6581 33.25H26.3281C25.9181 33.25 25.5781 32.91 25.5781 32.5C25.5781 32.09 25.9181 31.75 26.3281 31.75H29.6581C30.0681 31.75 30.4081 32.09 30.4081 32.5C30.4081 32.91 30.0681 33.25 29.6581 33.25Z",
    fill: "#D92D20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29.25H25.5C25.09 29.25 24.75 28.91 24.75 28.5C24.75 28.09 25.09 27.75 25.5 27.75H30.5C30.91 27.75 31.25 28.09 31.25 28.5C31.25 28.91 30.91 29.25 30.5 29.25Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.193285c7611369d039e3cf8f58682f61.svg";
export { ForwardRef as ReactComponent };